import React, {
  useContext,
  createContext,
  useState,
  useEffect,
  useMemo,
  PropsWithChildren,
} from 'react'; // eslint-disable-line
import { FeatureFlag } from '../../store/settings/reducer';

interface FeatureFlagContent {
  featureFlags: FeatureFlag[];
  setFeatureFlags: (flags: FeatureFlag[]) => void;
  isEnabled: (flagName: string) => boolean;
}

export const FeatureFlagContext = createContext<FeatureFlagContent>(
  {} as FeatureFlagContent,
);

export const FeatureFlagProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [featureFlags, setFeatureFlags] = useState<FeatureFlag[]>([]);

  useEffect(() => {
    if (isLoading && featureFlags.length) {
      setIsLoading(false);
    }
  }, [featureFlags]);

  const isEnabled = (flagName: string): boolean => {
    if (featureFlags.length) {
      const flag = featureFlags.find((flag) => flag.name === flagName);
      return flag ? flag.enabled : false;
    }
    return false;
  };

  const value = {
    featureFlags,
    setFeatureFlags,
    isEnabled,
  };

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlagContext = () => useContext(FeatureFlagContext);
